import React from "react";
import "./Sns.css";



const Sns = () => {
    return (
        <div className="sns-wrapper">
            <div className="works-title-wrapper">
                <span className="works-title-text">
                    SNS
                </span>
            </div>
            <section className="sns-body">
                <div className="sns-contents-wrapper">
                    <div className="sns-name">X</div>

                </div>
                <div className="sns-contents-body">
                    <div className="sns-contents-image"><img className="sns-image" src="/Image/x.png" alt="X-logo" /></div>

                    <div className="sns-account">
                       <a href="https://x.com/aoyamatar0" target="_blank">@aoyamatar0</a>
                    </div>
                </div>
            </section>

            <section className="sns-body">
                <div className="sns-contents-wrapper">
                    <div className="sns-name">Instagram</div>

                </div>
                <div className="sns-contents-body">
                    <div className="sns-contents-image"><img className="sns-image" src="/Image/instagram-logo.png" alt="X-logo" /></div>

                    <div className="sns-account">
                        <a href="https://www.instagram.com/chicken01nugget/" target="_blank">@chicken01nugget</a>
                    </div>
                </div>
            </section>

            <section className="sns-body">
                <div className="sns-contents-wrapper">
                    <div className="sns-name">Youtube</div>

                </div>
                <div className="sns-contents-body">
                    <div className="sns-contents-image"><img className="sns-image" src="/Image/youtube-logo.png" alt="X-logo" /></div>

                    <div className="sns-account">
                        <a href="https://www.youtube.com/@chicken01nugget" target="_blank">@chicke01nugget</a>
                    </div>
                </div>
            </section>

            <section className="sns-body">
                <div className="sns-contents-wrapper">
                    <div className="sns-name">note</div>

                </div>
                <div className="sns-contents-body">
                    <div className="sns-contents-image"><img className="sns-image note-logo" src="/Image/note-logo3.png" alt="X-logo" /></div>

                    <div className="sns-account">
                        <a href="https://note.com/aoyamatar0" target="_blank">@aoyamatar0</a>
                    </div>
                </div>
            </section>


        </div>
    );
}
export default Sns;